import { useSearchParams } from 'react-router-dom';
import CopilotPage from './CopilotPage';

/**
 * This component acts as a wrapper around the main CopilotPage.
 * Its purpose is to read URL query parameters and pass them as props.
 */
export default function CopilotPageWrapper({ onLogout }) {
    const [searchParams] = useSearchParams();

    // Read all the required parameters from the URL.
    // Note: the `customer` URL param actually carries a ClientCode (not a name),
    // matched against c.ClientCode downstream. Named accordingly to avoid confusion.
    const initialClientCode = searchParams.get('customer');
    const initialCountryCode = searchParams.get('countrycode');
    const initialContactId = searchParams.get('contactid');

    // spcalltype format: "<ClientCode> <LOB> <CallSubtype>" — but ClientCode may
    // contain spaces (e.g., "Test ATB HB EWT"). Locate the ClientCode substring in
    // spcalltype and take the first token after it as the LOB.
    const spCallType = searchParams.get('spcalltype') || '';
    let initialLob = null;
    if (initialClientCode) {
        const idx = spCallType.toLowerCase().indexOf(initialClientCode.toLowerCase());
        if (idx !== -1) {
            const remainder = spCallType.slice(idx + initialClientCode.length).trim();
            initialLob = remainder.split(/\s+/).filter(Boolean)[0] || null;
        }
    }

    return (
        <CopilotPage
            onLogout={onLogout}
            initialClientCode={initialClientCode}
            initialCountryCode={initialCountryCode}
            initialContactId={initialContactId}
            initialLob={initialLob}
        />
    );
}

